import { inject, Injectable, OnDestroy } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { AuthenticatedMode, AuthenticatedModeContainer } from "app/app.module";
import { Observable, of } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { LookupsService, Status } from "../../../app.services/lookups";
import { IBaseLookup } from "../../../app.services/lookups/lookups.types/interfaces/Ibase.lookup";
import { WebCalculations } from "../../../app.services/lookups/lookups.types/interfaces/web.calculations";
import { WebModelUpdates } from "../../../app.services/lookups/lookups.types/interfaces/web.model.updates";
import { OrganizationStructure } from "../../../app.services/org.struct";
import StatusDS = Status.StatusDS;
import WebCalculationDS = WebCalculations.WebCalculationsDS;
import WebModelUpdatesDS = WebModelUpdates.WebModelUpdatesDS;
import OrganizationStructureDS = OrganizationStructure.OrganizationStructureDS;

@UntilDestroy()
@Injectable({providedIn: 'root'})
export class ShellInitHelper implements OnDestroy{
	private lookupsObservable:Observable<IBaseLookup[]>;
	private lookupsData:IBaseLookup[];

	protected lookupsList=[ 
		Status.lookupName,
		{lookupName: WebCalculations.lookupName, includeClob: true},
		{lookupName: WebModelUpdates.lookupName, includeClob: true}
	];
	
	private lookupSvc: LookupsService = inject(LookupsService);

	// we rely on the authMode to determine if we need to load the organization structure.
	// we cannot override the injector with another inector for the ShellInitHelper for the PP
	// because this injector and others are used with provideIn:root and we cannot override the
	// root injector.
	private  authMode:AuthenticatedModeContainer = inject(AuthenticatedMode);

	constructor() {
		this.lookupsObservable = this.lookupSvc.getComplexLookups(this.lookupsList.concat(this.authMode.mode?[OrganizationStructure.lookupName]:[])).
			// set to shareReplay since this observable will later be subscribed on from other places (for example the
			// ClinicalStatusService) and we want to make sure they get the values - otherwise that subscriber will not run
			pipe(shareReplay(1));
		this.lookupsObservable.pipe(untilDestroyed(this)).subscribe(x=>{this.lookupsData=x;});
	}

	public available(){
		return this.lookupsObservable;
	}

	public ModelUpdates():WebModelUpdatesDS{
		return <WebModelUpdatesDS>this.lookupsData[2];
	}

	public OrganizationSturcture():Observable<OrganizationStructureDS>{
		if (this.authMode.mode){
			return this.lookupsObservable.pipe(map(x=><OrganizationStructureDS>x[3]));
		} else {
			// TODO - log
			// this is dirty but we have no choice. when we are not authenticated we do not 
			// receive the org structure. we cannot replace this provide with another
			// because of the provideIn:root approach. the workaround is to return an empty org structure
			// and then the code that uses it will not break.
			let retVal= of(<any>{ "orgStructure": [] });
			//console.log(retVal);
			return retVal;
		}
	}

	public WebCalcLookup():WebCalculationDS{
		return <WebCalculationDS>this.lookupsData[1];
	}

	public StatusLookup():Observable<StatusDS>{
		return this.lookupsObservable.pipe(map(x=><StatusDS>x[0]));
	}

	ngOnDestroy(): void {
	}
}
